import { Navigate, Route, Routes } from 'react-router';
import { isAuthenticated } from './auth/keycloak';
import { Shell, Start } from './components/shell';
import { AgentDetailPage } from './pages/agent-detail';
import { AgentFormPage } from './pages/agent-form';
import { AgentsPage } from './pages/agents';
import { RolesPage } from './pages/roles';
import { WorkflowsPage } from './pages/workflows';
import { AuditPage } from './pages/audit';
import { DecreesPage, NewDecreePage } from './pages/decrees';
import { Landing } from './pages/landing';
import { PositionsPage, ServicesPage } from './pages/organisation';
import { RequestsPage } from './pages/requests';

function RequireAuth({ children }: { children: React.ReactElement }) {
  return isAuthenticated() ? children : <Navigate to="/" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      >
        <Route path="/start" element={<Start />} />
        <Route path="/requests" element={<RequestsPage />} />
        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/agents/new" element={<AgentFormPage />} />
        <Route path="/agents/:id" element={<AgentDetailPage />} />
        <Route path="/agents/:id/edit" element={<AgentFormPage />} />
        <Route path="/workflows" element={<WorkflowsPage />} />
        <Route path="/roles" element={<RolesPage />} />
        <Route path="/decrees" element={<DecreesPage />} />
        <Route path="/decrees/new" element={<NewDecreePage />} />
        <Route path="/positions" element={<PositionsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/audit" element={<AuditPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
